import axios from 'axios';

export const sendLeadToZapier = async (data) => {
  try {
    const name = data.name || '';
    const email = data.email || '';
    const phone = data.phone || '';
    const message = data.message || data.notes || '';
    const language = data.language || 'en';
    const scenario = data.scenario || '';

    await axios.post(
      'https://us-central1-playbook-app-98755.cloudfunctions.net/sendToZapier',
      {
        name: name || "",
        email: email || "",
        phone: phone || "",
        message: message || "",
        language: language || "en",
        scenario: scenario || ""
      },
      {
        timeout: 3000,
      }
    );

    console.log('Zapier lead sent');
    return true;
  } catch (err) {
    console.error('Zapier error:', err);
    return false;
  }
};
